import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
var _dec, _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { Component, Vue } from 'nuxt-property-decorator';
import LayoutFoldable from '@/components/base/layout-foldable.vue';
import DocumentListItem from '@/components/document-list-item.vue';
import SearchResultSnippets from '@/components/search-result-snippets.vue';
import SearchResultsHeader from '@/components/search/search-results-header.vue';
import Preview from '@/components/preview.vue';
import SearchNavigationTab from '@/components/search/search-navigation-tab.vue';
import Pagination from '@/components/pagination.vue';
import KnowledgePanelKommentar from '@/components/search/knowledge-panel-kommentar.vue';
import * as Constants from '@/constants';
import { formatQuery, scrollToTop, snippetKey } from '@/utility';
import { generateSearchRoute, getPathFromSearchLocation } from '@/utils/routeUtils';
import { parseQuery } from '@/utils/searchUtils';
import { DocumentTypeEnum } from 'wklr-backend-sdk/models';
import FullverIntroductionDialog from '@/components/dialog/fullver-introduction-dialog.vue';
import FULLVER_INTRODUCTION from '@/assets/fullver-introduction.png';
import { shopifyDocDetailsUrl } from '@/utils/shopifyUtils';
import { endNavigationOrPageloadSpan } from '@/utils/sentryUtils';
/**
 * SearchResultEntry の hits から pageSeq を取り出して返す
 * extractPDF APIがソートして重複除去して返してくるので、ずれないようにしないといけない
 */
function extract(entry) {
  if (!(entry && entry.hits)) {
    // プレビュー対象なし
    return [];
  }
  var pagesToExtract = entry.hits.map(function (h) {
    return h.pageSeq;
  }).filter(function (seq) {
    return seq !== undefined;
  });
  pagesToExtract.sort(function (a, b) {
    return a - b;
  });
  for (var iter = 0; iter < pagesToExtract.length; iter += 1) {
    if (pagesToExtract[iter] === pagesToExtract[iter + 1]) {
      pagesToExtract.splice(iter, 1);
      iter -= 1;
      continue;
    }
  }
  return pagesToExtract;
}
var Search = (_dec = Component({
  components: {
    DocumentListItem: DocumentListItem,
    KnowledgePanelKommentar: KnowledgePanelKommentar,
    LayoutFoldable: LayoutFoldable,
    SearchNavigationTab: SearchNavigationTab,
    SearchResultSnippets: SearchResultSnippets,
    SearchResultsHeader: SearchResultsHeader,
    Pagination: Pagination,
    Preview: Preview,
    FullverIntroductionDialog: FullverIntroductionDialog
  },
  watchQuery: true
}), _dec(_class = /*#__PURE__*/function (_Vue) {
  function Search() {
    var _this;
    _classCallCheck(this, Search);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Search, [].concat(args));
    /** 結果 */
    _this.results = {};
    /**
     * 表示中のページ位置
     * 注：APIは0-index, URLクエリ文字列、Search.fromは1-index
     */
    _this.from = 1;
    /** 1ページあたりの表示文書数 */
    _this.perPage = Constants.Search.PerPage;
    // TODO: persistent store なのでこれは消せるかもしれない
    /** プリフェッチタイマー */
    _this.prefetchTimer = null;
    /** プリフェッチ待ち中の文書 */
    _this.prefetchTargetID = null;
    /** プレビューの初期ページ */
    _this.previewInitialPage = null;
    /** ページネーションをクリックした直後の beforeRouteUpdate は画面を最上部にスクロールさせる。そのためのフラグ */
    _this.isPaginationClicked = false;
    _this.showFullverIntroductionDialog = false;
    _this.fullverIntroduction = FULLVER_INTRODUCTION;
    _this.DocumentTypeEnum = DocumentTypeEnum;
    // TODO:API経由でDBから渡ってくる値を元に制御する予定
    // 今は仮でtrueを返すようにしている
    _this.shouldShowPreviewFlag = true;
    _this.shouldShowSnippetsFlag = true;
    return _this;
  }
  _inherits(Search, _Vue);
  return _createClass(Search, [{
    key: "restrictBookView",
    get: /** 書籍の表示を制限したい場合 */
    function get() {
      return this.$domain.isMHMMypage;
    }
  }, {
    key: "isFold",
    get: /** 詳細検索の表示 */
    function get() {
      return this.previewing === false;
    }

    /** プレビュー表示中かどうか */
  }, {
    key: "previewing",
    get: function get() {
      return this.$store.state.search.preview;
    },
    set: function set(value) {
      if (value === false) {
        this.$store.commit('setSelectedSnippet', null);
      }
      this.$store.commit('setPreview', value);
    }

    /** 見える範囲で、ESが強調してきたキーワードのリスト */
  }, {
    key: "highlightedKeywords",
    get: function get() {
      return this.searchQuery.keyword ? this.searchQuery.keyword.split(/\s+/).filter(function (keyword, i, all) {
        return keyword && all.indexOf(keyword) === i;
      }) : [];
    }
  }, {
    key: "previewEntry",
    get: function get() {
      var _this2 = this;
      return this.results.entries.filter(function (e) {
        return e.document.id === _this2.previewing;
      })[0];
    }

    /** 現在プレビュー対象となっている文書の、プレビューすべきページ番号のリスト */
  }, {
    key: "previewPageSeqs",
    get: function get() {
      if (this.results.entries === undefined) return {};
      return Object.fromEntries(this.results.entries.map(function (entry) {
        return [entry.document.id, extract(entry)];
      }));
    }
  }, {
    key: "searchQuery",
    get: function get() {
      return this.$store.state.search.query;
    },
    set: function set(value) {
      this.$store.commit('updateSearchQuery', value);
    }
  }, {
    key: "orderId",
    get: function get() {
      return this.$store.state.search.orderId;
    },
    set: function set(value) {
      this.$store.commit('setSearchOrderId', value);
    }
  }, {
    key: "order",
    get: function get() {
      return Constants.Search.Orders[this.orderId];
    }
  }, {
    key: "resultStatus",
    get: function get() {
      if (this.results && this.results.entries && this.results.entries.length > 0) {
        var from = (this.from - 1) * this.perPage + 1;
        var to = from + this.results.entries.length - 1;
        return {
          total: this.results.total || 0,
          from: from,
          to: to
        };
      } else {
        return {
          total: 0,
          from: 0,
          to: 0
        };
      }
    }
  }, {
    key: "asyncData",
    value: function () {
      var _asyncData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
        var _searchQuery$keyword;
        var app, query, route, searchQuery, page, perPage, order, results;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              app = _ref.app, query = _ref.query, route = _ref.route;
              searchQuery = !query.os ? parseQuery(query.q, app) // 通常の検索
              : {
                keyword: query.os,
                type: ['book']
              }; // Opensearch経由の検索
              page = Number.parseInt(query.p || '1', 10);
              perPage = Number.parseInt(query.n, 10) > 0 ? Number.parseInt(query.n, 10) : Constants.Search.PerPage;
              order = Constants.Search.Orders[Number.parseInt(query.o, 10)];
              _context.n = 1;
              return app.$repositories.searches.searchDocuments(searchQuery, perPage, page - 1, order ? order.value : undefined);
            case 1:
              results = _context.v;
              app.$telemetry.sendSearchTelemetry({
                keyword: (_searchQuery$keyword = searchQuery.keyword) !== null && _searchQuery$keyword !== void 0 ? _searchQuery$keyword : '',
                total: results.total
              }, route);
              return _context.a(2, {
                results: results,
                from: page,
                perPage: perPage
              });
          }
        }, _callee);
      }));
      function asyncData(_x) {
        return _asyncData.apply(this, arguments);
      }
      return asyncData;
    }()
  }, {
    key: "created",
    value: function created() {
      var observed = false;
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (observed) return;
          if (mutation.type === 'childList') {
            var target = document.querySelector('.wrapper-search-results');
            if (target) {
              endNavigationOrPageloadSpan();
              observed = true;
              observer.disconnect();
            }
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "head",
    value: function head() {
      var title = formatQuery(this.$store.state.search.query);
      return {
        title: title ? "".concat(title, "\u306E\u691C\u7D22\u7D50\u679C") : '検索中'
      };
    }
  }, {
    key: "paginationClickHandler",
    value: function paginationClickHandler() {
      this.isPaginationClicked = true;
    }
  }, {
    key: "hasPreviewPageSeqs",
    value: function hasPreviewPageSeqs(document) {
      var previewPageSeqs = this.previewPageSeqs[document.id];
      if (!previewPageSeqs) return false;
      return previewPageSeqs.length > 0;
    }

    /**
     * 新規にページが表示されたときのhook
     * @param to 新しいRoute
     * @param from 以前のRoute
     * @param next thisが利用可能になったときに呼ばれるcallbackを渡す
     */
  }, {
    key: "beforeRouteEnter",
    value: function beforeRouteEnter(to, from, next) {
      if (to.query.q || to.query.os) {
        next(function (vm) {
          var searchQuery = !to.query.os ? parseQuery(to.query.q, vm) : {
            keyword: to.query.os,
            type: ['book']
          }; // Opensearch経由の検索

          vm.searchQuery = searchQuery;
          vm.orderId = typeof to.query.o === 'string' ? Number.parseInt(to.query.o, 10) : Constants.Search.OrderId;
        });
      } else {
        next('/');
      }
    }

    /**
     * 同一ページでクエリパラメータが更新されたときのhook
     * @param to 新しいRoute
     * @param from 以前のRoute
     * @param next
     */
  }, {
    key: "beforeRouteUpdate",
    value: function beforeRouteUpdate(to, from, next) {
      var _this3 = this;
      if (to.query.q) {
        this.searchQuery = parseQuery(to.query.q, this);
        this.orderId = typeof to.query.o === 'string' ? Number.parseInt(to.query.o, 10) : Constants.Search.OrderId;
        this.previewing = false;
        this.$nextTick(function () {
          if (_this3.isPaginationClicked) {
            scrollToTop();
          }
        });
        next();
      } else {
        next('/');
      }
    }

    /** プレビューの表示・表示内容変更 */
  }, {
    key: "showPreview",
    value: function showPreview(docId, previewSeq) {
      var _this4 = this;
      var documentChanged = docId !== this.previewing;
      this.previewing = docId;
      if (documentChanged && previewSeq !== void 0) {
        this.previewInitialPage = this.previewPageSeqs[this.previewing].indexOf(previewSeq) + 1;
      }
      this.$store.commit('setPreview', docId);
      if (previewSeq !== undefined) {
        this.$store.commit('setSelectedSnippet', snippetKey(docId, previewSeq));
      } else {
        this.$store.commit('setSelectedSnippet', null);
      }
      this.$nextTick(function () {
        _this4.scrollToEntry(docId);
        if (previewSeq !== void 0 && typeof _this4.previewing === 'string') {
          _this4.$refs.previewViewer.scrollToIndex(_this4.previewPageSeqs[_this4.previewing].indexOf(previewSeq));
        }
      });
    }
  }, {
    key: "showPreviewForFirstSeq",
    value: function showPreviewForFirstSeq(document, entry) {
      this.showPreview(document.id, Array.isArray(entry.hits) && entry.hits.length > 0 ? entry.hits[0].pageSeq : undefined);
    }
  }, {
    key: "hidePreview",
    value: function hidePreview() {
      var _this5 = this;
      var preview = this.previewing;
      this.previewing = false;
      if (typeof preview === 'string') {
        this.$nextTick(function () {
          setTimeout(function () {
            return _this5.scrollToEntry(preview);
          }, 150);
        });
      }
    }
  }, {
    key: "scrollToEntry",
    value: function scrollToEntry(docId) {
      this.$refs["searchResultEntry-".concat(docId)][0].scrollIntoView({
        block: 'center'
      });
    }

    /**
     * 既存の検索条件に追加で著者名を指定して検索し直す
     * @param autor 著者名
     * @param event 実行時のイベント（Ctrlキーで別タブを開くため）
     */
  }, {
    key: "filterByAuthor",
    value: function filterByAuthor(author, event) {
      var query = _objectSpread({}, this.searchQuery);
      Vue.set(query, 'author', author);
      this.postSearch(query, event);
    }

    /**
     * 既存の検索条件に追加で発行元を指定して検索し直す
     * @param publisher 発行元
     * @param event 実行時のイベント（Ctrlキーで別タブを開くため）
     */
  }, {
    key: "filterByPublisher",
    value: function filterByPublisher(publisher, event) {
      var query = _objectSpread({}, this.searchQuery);
      Vue.set(query, 'publisher', [publisher]);
      this.postSearch(query, event);
    }

    /**
     * 既存の検索条件に追加で発行年月日（以前/以降）を指定して検索し直す
     * @param condition 以前/以降
     * @param publishedOn 発行年月日
     * @param event 実行時のイベント（Ctrlキーで別タブを開くため）
     */
  }, {
    key: "filterByPublishedOn",
    value: function filterByPublishedOn(condition, publishedOn, event) {
      var query = _objectSpread(_objectSpread({}, this.searchQuery), {}, {
        publishedOn: _objectSpread({}, this.searchQuery.publishedOn)
      });
      if (query.publishedOn === undefined) {
        Vue.set(query, 'publishedOn', {});
      }
      // yyyy-mm-ddTHH:MM:SSのうちyyyy-mm-ddだけを入れる
      Vue.set(query.publishedOn, condition, publishedOn.toString().replace(/T.*/, ''));
      this.postSearch(query, event);
    }
  }, {
    key: "storeDetailsUrl",
    value: function storeDetailsUrl(naturalId) {
      return shopifyDocDetailsUrl(naturalId);
    }

    /** 検索実行 */
  }, {
    key: "postSearch",
    value: function postSearch(query, event) {
      var to = generateSearchRoute(query, Constants.Search.option);
      if (event && (event.ctrlKey || event.metaKey)) {
        // Ctrl + クリックの場合は別タブで開き、元のページはそのまま
        window.open(getPathFromSearchLocation(to));
        return;
      }
      this.$router.push(to);
    }

    /** プリフェッチを管理する */
  }, {
    key: "prefetch",
    value: function prefetch(docRecord) {
      // 一旦忘れる
    }
  }, {
    key: "showKommentarKnowledgePanel",
    get: function get() {
      if (!this.searchQuery.keyword) return false;
      return this.searchQuery.keyword.includes('会社法') && this.searchQuery.keyword.includes('コンメ');
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              try {
                this.shouldShowPreviewFlag = true;
                this.shouldShowSnippetsFlag = true;
              } catch (error) {
                console.error('shouldShowPreviewFlag or shouldShowSnippetsFlag error:', error);
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function mounted() {
        return _mounted.apply(this, arguments);
      }
      return mounted;
    }()
  }]);
}(Vue)) || _class);
export { Search as default };